import {
  format,
  formatDistance,
  isAfter,
  isBefore,
  isSameDay,
  setHours,
  setMinutes,
  subWeeks,
} from "date-fns"
import utcToZonedTime from "date-fns-tz/utcToZonedTime"
import React from "react"

import Tooltip from "src/components/Tooltip"

export const handleError = (data, showToast) => {
  let errorMessage

  if (
    data.toString() ===
    "Error: Validation failed: to_status cannot equal from_status"
  ) {
    errorMessage =
      "The launch you are trying to update is already in the requested status. Please reload the page."
  } else if (data.toString() === "Error: Record could not be found") {
    errorMessage =
      "The requested launch cannot be found. Please contact mayday@dockwa.com if issues persist."
  } else {
    errorMessage =
      "There was a problem updating the launch. Please contact mayday@dockwa.com if issues persist."
  }

  showToast(errorMessage, {
    type: "error",
  })
}

export const timeHelper = (today, appointmentDate, timezone) => {
  const oneWeekAgo = subWeeks(today, 1)
  const appointmentTime = utcToZonedTime(appointmentDate, timezone)
  const formattedAppointmentDate = format(appointmentTime, "MM/dd/yy")
  const formattedAppointmentTime = format(appointmentTime, "p")
  const fullAppointmentTime = `${formattedAppointmentDate} at ${formattedAppointmentTime}`

  if (isSameDay(appointmentTime, today)) {
    // Anything launched/returned TODAY, show just time
    return {
      readableAppointmentTime: formattedAppointmentTime,
      fullAppointmentTime,
    }
  } else if (
    isBefore(appointmentTime, today) &&
    isAfter(appointmentTime, oneWeekAgo)
  ) {
    // Anything launched/returned 1-6 days ago, show “x days ago”
    const formattedAppointmentDaysAgo = formatDistance(appointmentTime, today, {
      addSuffix: true,
    })
    return {
      readableAppointmentTime: formattedAppointmentDaysAgo,
      fullAppointmentTime,
    }
  } else {
    // Anything launched/returned 7+ days ago, show just date
    return {
      readableAppointmentTime: formattedAppointmentDate,
      fullAppointmentTime,
    }
  }
}

export const timeCellContent = (appointment, allScheduledView) => {
  const today = new Date()

  if (["returned", "launched"].includes(appointment.status)) {
    const appointmentTime =
      appointment.status === "returned"
        ? appointment.returnedAt
        : appointment.launchedAt

    const { readableAppointmentTime, fullAppointmentTime } = timeHelper(
      today,
      appointmentTime,
      appointment.marinaTimezone
    )
    return (
      <Tooltip variant="light" text={fullAppointmentTime}>
        {readableAppointmentTime}
      </Tooltip>
    )
  } else {
    // "scheduled" tab
    const startTime = utcToZonedTime(
      appointment.startTime,
      appointment.marinaTimezone
    )
    const formattedStartTime = format(startTime, "p")
    const startTimeIsPassed = isAfter(today, startTime)
    const timeToDisplay = allScheduledView
      ? appointment.viewAllStartTime
      : formattedStartTime
    return (
      <>
        {startTimeIsPassed ? (
          <Tooltip variant="light" text={"The scheduled time has passed"}>
            <div className="flex items-center font-semibold text-red-600">
              <span className="mr-2">{timeToDisplay}</span>
              <i className="icon icon-clock text-sm font-semibold" />
            </div>
          </Tooltip>
        ) : (
          timeToDisplay
        )}
      </>
    )
  }
}

export const validateFutureTime = (selectedTime, selectedDate, timezone) => {
  const date = selectedDate
  const time = format(selectedTime, "HH:mm").split(":")

  const newDate = setHours(setMinutes(date, time[1]), time[0])

  return newDate > utcToZonedTime(new Date(), timezone)
}
